import { RoleProtected } from '../Components/RoleProtected';
import MobileNotificationView from '../Components/MobileNotificationPageComp/Views/MobileNotificationView';

export default function MobileNotificationPage() {
  return (
    <RoleProtected allowedRoles={["user", "Admin"]} showPageAction="mobile_notification_view">
      <MobileNotificationView />
    </RoleProtected>
  );
}